import React from "react";
import Heading from "components/ui/Heading/Heading";

const ViewSwitchesHeading = () => {
    return <Heading headingText={"View Switches"} />;
};

export default ViewSwitchesHeading;
